import { Component, Input, EventEmitter, Output } from '@angular/core';
import * as moment from 'moment-mini';
import { ScheduleItemStatusEnum, DetailView } from './aims-scheduler.classes';
import { TransferHttpService } from 'src/app/services/transfer-http/transfer-http.service';
import { ScheduleItem } from '../schCommon';
import { GetTextPipe } from 'src/app/pipes';


@Component({
  selector: 'aims-scheduler-detailview',
  styleUrls: ['./aims-scheduler.component.css'],
  templateUrl: './aims-scheduler-detailview.component.html',
  providers: [GetTextPipe],
  exportAs: 'schedulerDetailView'
})
export class AimsSchedulerDetailViewComponent {

  constructor(private transferHttp: TransferHttpService, private getTextPipe: GetTextPipe) {
  }

  @Input() detailView: DetailView;

  @Output() linkClicked: EventEmitter<ScheduleItem> = new EventEmitter();

  m = moment;
  siStatus = ScheduleItemStatusEnum;
  copas;

  showSpinner: boolean = false;
  spinnerText: string = "Loading...";

  //***************************
  // Widget Actions
  //***************************

  start: string;
  end: string;

  showScheduleItem(s) {
    this.showSpinner = true;
    this.transferHttp.getSingle(`Sch/GetScheduleItem?siId=${s.id}`).subscribe(s => {

      this.linkClicked.emit(new ScheduleItem(s))
      this.showSpinner = false;
    })
  }

  ngOnInit() {
   this.transferHttp.getSingle('Common/GetCopas').subscribe(ret => {
    this.copas = ret;
   });
  }

  insertOandA(resource) {
    return (resource.oanumber != null) ? ' O&A #' + resource.oanumber + ' ': '';
  }

  insertCopa(resource) {
    return (resource.copaId != null) ? ' DSW COPA #' + this.getCopaNumber(resource.copaId) + ' ' : '';
  }

  getCopaNumber(copaId: number) {
    return this.getTextPipe.transform(copaId, 'copaId', 'copaNumber', this.copas);
  }
}
